import mainfeatureslideshow from './mainFeatureSlide.js';

export default function () {
  const widgetName = 'cardWidgetvideo';
  // eslint-disable-next-line no-undef
  const widgetOpts = cardWidgetVideoOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (widgetData) {
      function customVimeoWidget() {
        $(`#${widgetName} .card-widget-item`).each(function (x) {
          let vimeoURLAttr = $(widgetData.items[x].Description).find('iframe').attr('src');
          $(this)
            .find('.card-widget-description iframe')
            .attr('src', `${vimeoURLAttr}&background=1`);
          $(this).find('.card-widget-title').remove();
          $(this).find('.buttonwrap').remove();
        });

        if (widgetData.items.length === 0) {
          $(`#${widgetName}`).remove();
          mainfeatureslideshow();
        } else {
          $('.saffireLargeSize #mainFeatureSlideShow').remove();

          // Add class to body if video is active
          $('body').addClass('video-active');
        }
      }

      customVimeoWidget();
    },

    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}
